<!-- <div class="border border-gray-200 rounded-xl p-5"> -->
<!-- Header -->
<div class="min-h-screen flex justify-between items-center border-b">
  <!-- LEFT: TEXT -->
  <div class="flex flex-col max-w-[60%]">
    <span class="text-xl font-semibold text-gray-900 mb-2">
      {{ resolvePlaceholders(fields.displayName) }}
    </span>

    <span class="text-sm text-gray-800">
      {{ resolvePlaceholders(fields.helpText) }}
    </span>
  </div>

  <!-- RIGHT: IMAGE -->
  <div class="flex justify-end items-center">
    <img
      [src]="
        fields.uiOptions.image
          ? fields.uiOptions.image
          : './assets/media/illustrations-image/illustration-2.png'
      "
      class="h-175px object-contain"
    />
  </div>
</div>
<!-- Cards -->
<!-- <div
    class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6"
    *ngIf="isLoading"
  >
    <div
      *ngFor="let s of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
      class="bg-white dark:bg-coal-700 border rounded-xl p-5 flex flex-col items-center justify-center relative"
    >
      <div class="absolute top-0 left-3">
        <div
          class="shimmer-item bg-gray-300 dark:bg-coal-700 w-7 h-7 rounded"
        ></div>
      </div>

      <div
        class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded w-14 h-10 mb-4 mt-3"
      ></div>

      <div
        class="shimmer-item bg-gray-300 dark:bg-coal-700 w-24 h-4 rounded mb-2"
      ></div>

      <div
        class="shimmer-item bg-gray-300 dark:bg-coal-700 w-36 h-4 rounded"
      ></div>
    </div>
  </div>
  <div class="graph-card flex justify-center overflow-y-auto gap-3 p-2">
    <div
      *ngIf="!isLoading && fieldsData.length > 0"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4 w-full max-w-6xl"
    >
      <ng-container *ngFor="let item of fieldsData">
        <div
          class="cursor-pointer border border-gray-200 rounded-xl p-3 flex flex-row items-start hover:bg-secondary-active transition-shadow"
        >
          <div class="flex flex-col">
            <div class="flex flex-row items-center">
            
              <img
                src="./assets/media/data-view/integration.png"
                class="w-7 h-7 mb-3"
              />
              
              <span
                class="text-sm font-semibold text-gray-800 mb-1 break-words max-w-full ms-2"
                [title]="item.name"
              >
                {{ item.name.slice(0, 20)
                }}{{ item.name.length > 20 ? "..." : "" }}
              </span>
            </div>
            
            <p
              class="text-sm text-gray-500 text-start break-words max-w-full"
              [title]="item.description"
            >
              {{ item.description.slice(0, 24)
              }}{{ item.description.length > 24 ? "..." : "" }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="flex flex-1 items-center justify-center text-center flex-col graph-card"
    *ngIf="fieldsData?.length == 0"
  >
    <span class="text-md text-gray-900 font-medium">No Data Available</span>
    <span class="text-sm text-gray-800">There is no data to display yet</span>
  </div> -->
<!-- Footer -->
<!-- <div
    class="mt-4 min-h-screen flex justify-center items-center border border-gray-200 rounded-xl p-5"
  >
    <div class="placeholder flex flex-col items-start text-start">
      <span class="text-md text-gray-900 font-semibold">{{
        resolvePlaceholders(fields.uiOptions?.text)
      }}</span>
      <span class="text-2sm text-gray-700 font-medium w-500px mt-1">{{
        resolvePlaceholders(fields.uiOptions?.subText)
      }}</span>
    </div>
    <div class="ms-auto">
      <button
        *ngIf="fields?.properties?.buttonProperty?.text"
        [ngStyle]="fields.properties.buttonProperty.style"
        (click)="handleButtonClick(fields)"
      >
        {{ fields.properties.buttonProperty.text }}
      </button>
    </div>
  </div> -->
<!-- </div> -->
